<template>
  <div class="check-data-zip">
    <el-dialog
      :show-close="false"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="45%"
      :close="handleClose"
    >
      <div
        slot="title"
        style="background-color:#357cf2;color:#FFF;height: 45px;line-height:45px"
      >
        数据包查看
      </div>
      <el-row>
        <el-col class="col-data-check" :span="12">
          <el-checkbox v-model="dataZipCheck.a">当期数据报表</el-checkbox>
          <!-- <a style="color:#357cf2" @click="detail" >查看</a> -->
        </el-col>
        <el-col class="col-data-check" :span="12">
          <el-checkbox v-model="dataZipCheck.b">累计数据报表</el-checkbox>
          <!-- <a style="color:#357cf2" @click="detail" >查看</a> -->
        </el-col>
        <el-col class="col-data-check" :span="12">
          <el-checkbox v-model="dataZipCheck.c">当期任务记录</el-checkbox>
          <!-- <a style="color:#357cf2" @click="detail" >查看</a> -->
        </el-col>
        <el-col class="col-data-check" :span="12">
          <el-checkbox v-model="dataZipCheck.d">累计任务记录</el-checkbox>
          <!-- <a style="color:#357cf2" @click="detail" >查看</a> -->
        </el-col>
        <el-col class="col-data-check" :span="12">
          <el-checkbox v-model="dataZipCheck.e">当期BI报告</el-checkbox>
          <a style="color:#357cf2" @click="detail">预览</a>
        </el-col>
        <el-col class="col-data-check" :span="12">
          <el-checkbox v-model="dataZipCheck.f">累计BI报告</el-checkbox>
          <a style="color:#357cf2" @click="detail">预览</a>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { projectAllList } from '@/config/staticData';

import { createLogger } from 'vuex';
export default {
  props: ['dialogVisible', 'scope'],

  data() {
    return {
      dataZipCheck: {
        a: false,
        b: false,
        c: false,
        d: false,
        e: false,
        f: false
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      console.log('init');
    },
    handleClose() {
      this.$emit('done');
    },
    submit() {
      this.handleClose();
    },
    detail() {
      let scope = this.scope;
      //     let obj = {};
      // projectAllList.filter((item, index) => {
      //     obj[index + 1] = {
      //     name: item.filePath + 'RecordList',
      //     query: [5, 7].includes(index + 1) ? type2 : type1
      //     };
      // });
      // const pathInfo = obj[name];
      // this.$router.push({
      //     name: pathInfo.name,
      //     query: pathInfo.query
      // });
      //     return
      // 如果甲乙都确认了则可使用个人BI导出功能 industryConfirm:1为甲方确认 csoStatus:1为乙方确认
      localStorage.setItem(
        'exportPersonalBiDisabled',
        !(scope.row.industryConfirm && scope.row.csoStatus) ||
          scope.row.biSwitch === '1'
      );
      //点击详情
      let name = localStorage.projectType;
      if (scope.row.authType) {
        localStorage.setItem('authType', scope.row.authType);
      }
      let projectId = scope.row.projectId;
      let month = scope.row.taskMonth;
      let id = this.$route.query.id;
      let { row } = scope;
      localStorage.setItem('authType', row.authType);
      const type1 = {
        projectId,
        month,
        id: projectId,
        taskMonth: month
      };
      const type2 = {
        projectId,
        month,
        id: projectId,
        questionnaireAnswerId: id,
        taskMonth: month
      };
      let obj = {};
      projectAllList.filter((item, index) => {
        obj[index + 1] = {
          name: item.filePath + 'RecordList',
          query: [5, 7].includes(index + 1) ? type2 : type1
        };
      });
      const pathInfo = obj[name];
      this.$router.push({
        name: pathInfo.name,
        query: pathInfo.query
      });
    }
  }
};
</script>

<style lang="scss">
.check-data-zip {
  .el-dialog__header {
    padding: 0 !important;
  }
  .col-data-check {
    margin: 20px 0 !important;
  }
}
</style>
